import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { PublicQuoteComponent } from '@bandido/shared/types';
export function InsuranceCoverage({ coverage: c }: { coverage: NonNullable<PublicQuoteComponent['insurance']> }) {
  const { t } = useTranslation();
  const tr = (key: string) => t(`travelServices.insurance.${key}`);
  return (
    <Stack spacing={0.5}>
      <Typography>
        {tr('coverage')}: {c.coverageArea}
      </Typography>
      <Typography variant="body2">
        {tr('coverageDates')}: {c.coverageStart} → {c.coverageEnd}
      </Typography>
      {c.familyPlan && <Typography variant="body2">{tr('family')}</Typography>}
      {c.maxTripDays !== undefined && (
        <Typography variant="body2">
          {tr('annual')} · {t('travelServices.insurance.maxTrip', { days: c.maxTripDays })}
        </Typography>
      )}
      {c.maxAge !== undefined && (
        <Typography variant="body2">{t('travelServices.insurance.maxAge', { age: c.maxAge })}</Typography>
      )}
      {c.benefits.length ? (
        c.benefits.map((b, i) => (
          <Typography key={i} variant="body2">
            {b.description}
            {b.limit ? ` · ${b.limit}` : ''}
          </Typography>
        ))
      ) : (
        <Typography variant="body2">{tr('noBenefits')}</Typography>
      )}
    </Stack>
  );
}
